import { useMemo } from 'react';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import WorkOrderDatePicker from '.';
import styles from './WorkOrderDatePicker.module.scss';

interface DateRangeFieldsProps {
  value: [string, string];
  onChange: (value: [string, string]) => void;
}

// FROM / TO pickers bounded by each other; shared by the filter, the status update and the work order form.
const DateRangeFields = ({ value, onChange }: DateRangeFieldsProps) => {
  const [fromIso, toIso] = value;
  const fromDate = useMemo(() => (fromIso ? dayjs(fromIso) : null), [fromIso]);
  const toDate = useMemo(() => (toIso ? dayjs(toIso) : null), [toIso]);

  // Whole days, so the range includes both picked dates; '' marks an unset side.
  const handleFromChange = (date: Dayjs | null) => onChange([date ? date.startOf('day').toISOString() : '', toIso]);
  const handleToChange = (date: Dayjs | null) => onChange([fromIso, date ? date.endOf('day').toISOString() : '']);
  const isAfterTo = (current: Dayjs) => Boolean(toDate && current.isAfter(toDate, 'day'));
  const isBeforeFrom = (current: Dayjs) => Boolean(fromDate && current.isBefore(fromDate, 'day'));

  return (
    <>
      <label className={styles.dateRangeRow}>
        From:
        <WorkOrderDatePicker variant="borderless" value={fromDate} onChange={handleFromChange} disabledDate={isAfterTo} />
      </label>
      <label className={styles.dateRangeRow}>
        To:
        <WorkOrderDatePicker variant="borderless" value={toDate} onChange={handleToChange} disabledDate={isBeforeFrom} />
      </label>
    </>
  );
};

export default DateRangeFields;
